<div class="ac-page c7-access-view c7-access-update-password">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <button type="button" class="ac-topbar__back" (click)="goBack()">{{ "authPages.back" | translate }}</button>
      <a class="ac-brand" href="javascript:void(0)" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center">
    <section class="ac-card ac-card--single" aria-labelledby="ac-title">
      <div class="ac-card__head">
        <h2 id="ac-title">{{ "authPages.updateTitle" | translate }}</h2>
      </div>

      <form [formGroup]="changePasswordForm" (ngSubmit)="updatepassword()" novalidate class="ac-form">
        <div class="ac-field">
          <label for="ac-old">{{ "authPages.current" | translate }}</label>
          <div class="ac-input-wrap">
            <input id="ac-old" [type]="oldPasswordVisible ? 'text' : 'password'" formControlName="old_password" autocomplete="current-password"
              [attr.aria-invalid]="(submitted || f['old_password'].touched) && f['old_password'].invalid ? 'true' : 'false'" />
            <button type="button" class="ac-toggle" (click)="oldPasswordVisibility()"
              [attr.aria-label]="(oldPasswordVisible ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
              <img [src]="oldPasswordVisible ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
            </button>
          </div>
          <span class="ac-error" *ngIf="submitted && f['old_password'].hasError('required')" aria-live="polite">{{ "authPages.currentRequired" | translate }}</span>
        </div>
        <div class="ac-field">
          <label for="ac-new">{{ "authPages.new" | translate }}</label>
          <div class="ac-input-wrap">
            <input id="ac-new" [type]="newPasswordVisible ? 'text' : 'password'" formControlName="new_password" autocomplete="new-password"
              [attr.aria-invalid]="(submitted || f['new_password'].touched) && f['new_password'].invalid ? 'true' : 'false'" />
            <button type="button" class="ac-toggle" (click)="newPasswordVisibility()"
              [attr.aria-label]="(newPasswordVisible ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
              <img [src]="newPasswordVisible ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
            </button>
          </div>
          <span class="ac-error" *ngIf="submitted && f['new_password'].hasError('required')" aria-live="polite">{{ "authPages.newRequired" | translate }}</span>
          <span class="ac-error" *ngIf="submitted && f['new_password'].hasError('minlength')" aria-live="polite">{{ "authPages.minLength" | translate: { min: minLength } }}</span>
          <app-password-rules [password]="changePasswordForm.value.new_password || ''"></app-password-rules>
        </div>
        <div class="ac-field">
          <label for="ac-confirm">{{ "authPages.confirm" | translate }}</label>
          <div class="ac-input-wrap">
            <input id="ac-confirm" [type]="confirmPasswordVisible ? 'text' : 'password'" formControlName="confirm_password" autocomplete="new-password"
              [attr.aria-invalid]="(submitted || f['confirm_password'].touched) && f['confirm_password'].invalid ? 'true' : 'false'" />
            <button type="button" class="ac-toggle" (click)="confirmPasswordVisibility()"
              [attr.aria-label]="(confirmPasswordVisible ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
              <img [src]="confirmPasswordVisible ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
            </button>
          </div>
          <span class="ac-error" *ngIf="submitted && f['confirm_password'].hasError('required')" aria-live="polite">{{ "authPages.confirmRequired" | translate }}</span>
          <span class="ac-error" *ngIf="submitted && f['confirm_password'].hasError('confirmPasswordValidator')" aria-live="polite">{{ "authPages.mismatch" | translate }}</span>
        </div>

        <button class="ac-btn" type="submit">{{ "authPages.updateSubmit" | translate }}</button>
        <p class="ac-error ac-error--block" *ngFor="let msg of serverErrors" role="alert">{{ msg }}</p>
        <p class="ac-error ac-error--block" *ngIf="errormsg" role="alert">{{ errormsg | translate }}</p>
      </form>
    </section>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
